import { useMemo, useReducer } from "react";
import { initialState, OrgContextReducer } from "./org-context-reducer";
import { OrgContext, OrgContextDispatch, OrgHoverContext } from "./org-context";

export const OrgContextProvider = ({ children }) => {
  const [context, dispatch] = useReducer(OrgContextReducer, initialState)

  const stableValue = useMemo(() => ({
    activeOrgs: context.activeOrgs,
    lastSelectedFarmId: context.lastSelectedFarmId,
    lastSelectedSeasonId: context.lastSelectedSeasonId,
    seasonListRefreshKey: context.seasonListRefreshKey,
  }), [context.activeOrgs, context.lastSelectedFarmId, context.lastSelectedSeasonId, context.seasonListRefreshKey])

  const hoverValue = useMemo(() => ({
    hoveredOrg: context.hoveredOrg,
    hoveredTask: context.hoveredTask,
    hoveredTaskGap: context.hoveredTaskGap,
  }), [context.hoveredOrg, context.hoveredTask, context.hoveredTaskGap])

  return (
    <OrgContext.Provider value={stableValue}>
      <OrgHoverContext.Provider value={hoverValue}>
        <OrgContextDispatch.Provider value={dispatch}>
          {children}
        </OrgContextDispatch.Provider>
      </OrgHoverContext.Provider>
    </OrgContext.Provider>
  )
}
